import CartActionTypes from "../../actionTypes/cart"
import { getCart } from "../../reducers"

const updateAttributesAction = (attributes) => (dispatch, getState) => {
  if (!attributes) {
    return;
  }

  const {checkout, client, isLoading} = getCart(getState());

  if (isLoading === true) {
    return;
  }

  if (!checkout) {
    console.error('A checkout is required');

    return;
  }

  dispatch({
    type: CartActionTypes.UPDATING_ATTRIBUTES_ACTION
  });

  const checkoutId = checkout.id;

  let input = {note: attributes}


  return client.checkout
    .updateAttributes(checkoutId, input)
    .then(() => {
      processAttributesUpdate(dispatch, client, checkout);
    });
};

function processAttributesUpdate(dispatch, client, checkout) {

  dispatch({
    type: CartActionTypes.DISCOUNT_ADD_ACTION,
    payload: {
      client: client,
      checkout: checkout
    }
  });
}

export {
  updateAttributesAction
}
